/**
 * A reviewer's name shown as first initial and surname, so a customer's full name is never
 * published. Single-word names (as many review platforms show) are left as they are.
 */
export function shortName(name = "") {
  const clean = name.trim();
  // Platform placeholders such as "Verified Checkatrade customer" are not personal names.
  if (/customer|anonymous/i.test(clean)) return clean;
  const parts = clean.split(/\s+/).filter(Boolean);
  if (parts.length < 2) return name.trim();
  const surname = parts[parts.length - 1];
  return `${parts[0][0].toUpperCase()}. ${surname}`;
}
